import React from 'react';
import { Link } from 'react-router-dom';
import './Cards.css';

function CardItem({ label, path, src, text }) {
  return (
    <>
      <li className="cards-item">
        <Link className="cards-item-link" to={path}>
          <figure className="cards-item-pic-wrap" data-category={label}>
            <img 
              className="cards-item-img" 
              alt={text}
              src={src}
              loading="lazy"
              decoding="async"
            />
          </figure>
          <div className="cards-item-info">
            <p className="cards-item-text">{text}</p>
          </div>
        </Link>
      </li>
    </>
  )
}

export default CardItem;
